(ns manatee.auth.ids)

(def login-alert-banner :login-alert-banner)
